export const translatedLanguages = [
  {
    name: "English",
    code: "en",
    nativeName: "English",
    flag: "🇺🇸",
  },
  {
    name: "Chinese",
    code: "zh",
    nativeName: "中文",
    flag: "🇹🇼",
  },
  {
    name: "Japanese",
    code: "ja",
    nativeName: "日本語",
    flag: "🇯🇵",
  },
  {
    name: "Thai",
    code: "th",
    nativeName: "ภาษาไทย",
    flag: "🇹🇭",
  },
];
